<template>
  <!-- 
    no-close-on-backdrop -> Orqa fonga bosilganda yopilmaydi
    no-close-on-esc -> ESC bosilganda yopilmaydi
    @shown -> Modal ochilganda inputga fokus qaratish
  -->
  <b-modal 
    :visible="value" 
    @change="val => $emit('input', val)"
    :title="form.id ? $t('Kursni tahrirlash') : $t('Yangi kurs kiritish')" 
    hide-footer 
    centered 
    no-close-on-backdrop
    no-close-on-esc
    @shown="FocusInput"
  >
    <form @submit.prevent="SaveData">
      <div class="form-group">
        <label class="font-weight-bold text-secondary">{{ $t("Kurs qiymati") }}</label>
        <div class="input-with-icon">
          <input 
            ref="rateInput"
            v-model="form.rate" 
            type="number" 
            step="0.01" 
            class="form-control modern-input"
            :placeholder="$t('Masalan: 12850')" 
            required
          >
        </div>
      </div>

      <div class="modal-custom-footer mt-4 pt-3 border-top">
        <button type="button" class="m-btn cancel-btn" @click="$emit('input', false)">
          {{ $t("Bekor qilish") }}
        </button>
        <button type="submit" class="m-btn save-btn" :disabled="saving">
          <b-spinner small v-if="saving" class="mr-1"></b-spinner>
          {{ saving ? $t('Saqlanmoqda...') : $t('Saqlash') }}
        </button>
      </div>
    </form>
  </b-modal>
</template>

<script>
export default {
  props: {
    value: { type: Boolean, default: false }, // v-model uchun
    itemData: { type: Object, default: () => ({ id: null }) }
  },
  data() {
    return {
      form: { id: null, rate: null, datetime: null },
      saving: false
    };
  },
  watch: {
    value(val) {
      if (val) {
        if (this.itemData && this.itemData.id) {
          // Tahrirlash rejimi
          this.form = { ...this.itemData };
        } else {
          // Qo'shish rejimi
          this.form = { id: null, rate: null, datetime: null };
        }
      }
    }
  },
  methods: {
    FocusInput() {
      // Modal ochilganda avtomatik inputga yozishni boshlash
      if(this.$refs.rateInput) this.$refs.rateInput.focus();
    },
    SaveData() {
      if (!(this.form.rate > 0)) {
        this.$bvToast.toast(this.$t("Kurs noto'g'ri kiritildi"), { variant: 'warning' });
        return;
      }
      
      this.saving = true;

      const payload = {
        rate: Number(this.form.rate),
        // Agar tahrirlash bo'lsa eski vaqt qoladi, yangi bo'lsa hozirgi vaqt
        datetime: this.form.id ? this.form.datetime : Math.floor(Date.now() / 1000)
      };

      let url = this.form.id ? `api/v1/dollar-exchange-rate/id/${this.form.id}` : "api/v1/dollar-exchange-rate";
      let method = this.form.id ? "patch" : "post";

      axios({ method, url, data: payload })
        .then(() => {
          this.$emit('saved'); // Muvaffaqiyatli saqlandi
          this.$emit('input', false); // Modalni yopish
          this.$bvToast.toast(this.$t("Muvaffaqiyatli saqlandi"), { variant: 'success' });
        })
        .catch((err) => {
          console.error(err);
          this.$bvToast.toast(this.$t("Saqlashda xato yuz berdi"), { variant: 'danger' });
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>

<style scoped>
.modern-input {
  height: 50px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 0 15px;
  font-size: 18px;
  font-weight: 700;
  color: #2d3748;
}
.input-with-icon {
  position: relative;
  display: flex;
  align-items: center;
}

.modal-custom-footer {
  display: flex;
  gap: 10px;
}
.m-btn {
  flex: 1;
  padding: 12px;
  border-radius: 14px;
  border: none;
  font-weight: 700;
  cursor: pointer;
  transition: 0.2s;
}
.cancel-btn {
  background: #f1f5f9;
  color: #64748b;
}
.save-btn {
  background: #a142f4;
  color: white;
}
</style>